export const state = {
  opportunityEconomies: [],
  isLoading: false,
  totalRecords: 0,
  opportunityEconomyPerPage: 10000,
  activePage: 1
}
